var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","color":_vm.color,"small":_vm.small,"fab":"","loading":_vm.loading,"x-small":_vm.xSmall},on:{"click":_vm.onClick}},[_c('v-icon',{staticClass:"edit-icon"},[_vm._v(_vm._s(_vm.iconSource))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }